import { useAppDispatch, useAppSelector } from '@libs/redux/hooks'

import { Organization } from '@types'

import { appSlice } from '@libs/redux/app/app.slice'

export type SignInInput = {
  grantType: 'password' | 'refresh_token' | 'code'
  email?: string
  password?: string
  refreshToken?: string
  code?: string
}

export const useAppState = (): {
  organization?: Organization | null
  getOrganization: () => Organization
  setOrganization: (organization: Organization | null) => void
  isSideBarMenuOpen: boolean
  setSideBarMenuOpen: (isOpen: boolean) => void
  isZoningHintOpen: boolean
  setZoningHintOpen: (isOpen: boolean) => void
  isZoomingPlanning: boolean
  setZoomingPlanning: (isZooming: boolean) => void
  clearAppSate: () => void
} => {
  const organization = useAppSelector((state) => state.app.organization)

  const dispatch = useAppDispatch()

  function setOrganization(organization: Organization | null) {
    dispatch(appSlice.actions.setOrganization({ organization }))
  }

  const getOrganization = (): Organization => {
    if (!organization) {
      throw new Error('"getOrganization" function must be used in child Component tree of "withOrganizationGuard"')
    }
    return organization
  }

  const isSideBarMenuOpen = useAppSelector((state) => state.app.isSideBarMenuOpen)

  function setSideBarMenuOpen(isOpen: boolean) {
    dispatch(appSlice.actions.setSideBarMenuOpen({ isOpen }))
  }

  const isZoningHintOpen = useAppSelector((state) => state.app.isZoningHintOpen)

  function setZoningHintOpen(isOpen: boolean) {
    dispatch(appSlice.actions.setZoningHintOpen({ isOpen }))
  }

  const isZoomingPlanning = useAppSelector((state) => state.app.isZoomingPlanning)

  function setZoomingPlanning(isZooming: boolean) {
    dispatch(appSlice.actions.setZoomingPlanning({ isZooming }))
  }

  function clearAppSate() {
    dispatch(appSlice.actions.clearAppState())
  }

  return {
    organization,
    getOrganization,
    setOrganization,
    isSideBarMenuOpen,
    setSideBarMenuOpen,
    isZoningHintOpen,
    setZoningHintOpen,
    isZoomingPlanning,
    setZoomingPlanning,
    clearAppSate,
  }
}
